
import { Set } from '~commonInfra/utils/Set';
import { Messages } from '~src/codegen/Localize';
import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';
import { L10n } from '~src/commonInfra/L10n/L10n';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { openDeleteGroupSetConfirmationDialog } from '../../components/DeleteGroupSetConfirmationDialog';
import { GroupSets } from '../../GroupSets';
import { IGroupSetBasicInfo, IGroupSetInfo } from '../../models/IGroupSetInfo';
import { DeleteGroupSetsNotificationAction } from '../notifications/DeleteGroupSetsNotificationAction';


function showDeleteGroupSetDialog(
    groupSets: Set<IGroupSetInfo>): Promise<any> {

    let dialogBody: string;

   if (groupSets.size() === 1) {
      const group = groupSets.first();
      dialogBody = Messages.confirmDeleteGroupSet({ GROUPSET_NAME: L10n.elideIfLong(group.name) });
    } else {
      dialogBody = Messages.confirmDeleteGroupSets({ GROUPSET_COUNT_LOC: L10n.localizedCount(groupSets.size()) });
    }

    const dialogInstance = openDeleteGroupSetConfirmationDialog<string[], IResult>({
      title: groupSets.size() === 1 ? Messages.deleteGroupSetMessage(): Messages.deleteMultipleGroupSetsMessage(),
      message: dialogBody,
      actionName: Messages.confirmDeleteButton({ ITEM_COUNT: groupSets.size() , ITEM_COUNT_LOC: L10n.localizedCount(groupSets.size()) }),
      isActionDelete: true,
      action: GroupSets.deleteGroupSets.bind(groupSets),
      paramsForAction: groupSets.keys(),
      dialogWidth: TabDialogWidth.width375px,
    });

    dialogInstance.result.then((result: IResult) => {
      DeleteGroupSetsNotificationAction.notify(result, groupSets);
    });

    return Promise.resolve(dialogInstance.result);
}

function deleteGroupSet(groupSet: IGroupSetBasicInfo): Promise<any> {
    const groupSets = new Set<IGroupSetBasicInfo>((groupSet: IGroupSetInfo) => groupSet.id);
    groupSets.add(groupSet);
    return DeleteGroupSetAction.showDeleteGroupSetDialog(groupSets);
}

export const DeleteGroupSetAction = {
    showDeleteGroupSetDialog,
    deleteGroupSet
};


  export type DeleteGroupSetAction = typeof DeleteGroupSetAction;
